
import colors from '../../../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        actions: {
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
        },
        authenticatorCodeContainer: {
            paddingTop: theme.spacing(2)
        },
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px',
                marginLeft: '10px',
                width: '104px'
            }
        },
        buttonContainer: {
            '@media screen and (max-width: 320px)': {
                paddingBottom: '20px',
                paddingTop: '24px'
            },
            backgroundColor: colors[mode].primaryBackground,
            height: '100%'
        },
        content: {
            fontSize: '24px',
            fontWeight: '500'
        },
        contentContainer: {
            borderRadius: '3px',
            boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)'
        },
        contentDivider: {
            paddingTop: '25px'
        },
        contentSection: {
            fontSize: '20px'
        },
        countdown: {
            marginLeft: '10px',
            marginTop: '-10px',
            position: 'relative',
        },
        countdownProgress: {
            color: colors[mode].mobileIcon
        },
        countdownTypography: {
            left: '50%',
            position: 'absolute',
            top: '45%',
            transform: 'translate(-50%, -50%)',
        },
        disabledLink: {
            alignSelf: 'start',
            color: '#60666D',
            display: 'flex',
        },
        divider: {
            background: '#FFC72A',
            padding: '2px',
            width: '50px'
        },
        fieldsContainer: {
            alignItems: 'center',
            background: colors[theme.palette.mode].primaryBackground,
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            justifyContent: 'space-between',
            minHeight: '316px',
            padding: '16px 26px',
            width: '92%'
        },
        hide: {
            display: 'none'
        },
        link: {
            alignSelf: 'start',
            display: 'flex'
        },
        loader: {
            height: '100%',
            left: '0',
            position: 'absolute',
            top: '0',
            width: '100%',
            'z-index': '10'
        },
        root: {
            padding: theme.spacing(0, 2, 2, 2)
        },
        show: {
            display: 'block'
        },
        successMsg: {
            color: theme.palette.success.main
        }
    }
}
        
export default styles
